export default __webpack_public_path__ + "static/media/a037-2.0f840be4.svg";